<template>
  <div class="desktop-search desktop-container">
    <div>
      <div class="class-main">
        <div class="type-main">
          <div class="search-title">类型:</div>
          <div
            v-for="(item, index) in typeList"
            :key="index"
            :class="
              searchForm.type == item.id
                ? 'class-li class-li-active'
                : 'class-li'
            "
            @click="changeType(item.id, 'type')"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="category-main">
          <div class="search-title">类别:</div>
          <div class="items">
            <span
              :class="
                searchForm.category == 0
                  ? 'class-li class-li-active'
                  : 'class-li'
              "
              @click="changeType(0, 'category')"
            >
              全部
            </span>
            <span
              v-for="(item, index) in categoryList"
              :key="index"
              :class="
                searchForm.category == item.id
                  ? 'class-li class-li-active'
                  : 'class-li'
              "
              @click="changeType(item.id, 'category')"
            >
              {{ item.category_name }}
            </span>
          </div>
        </div>
        <div class="group-main">
          <div class="search-title">群体:</div>
          <div
            :class="
              searchForm.group == 0 ? 'class-li class-li-active' : 'class-li'
            "
            @click="changeType(0, 'group')"
          >
            全部
          </div>
          <div
            v-for="(item, index) in groupList"
            :key="index"
            :class="
              searchForm.group == item.id
                ? 'class-li class-li-active'
                : 'class-li'
            "
            @click="changeType(item.id, 'group')"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="ul-main">
      <text-list :list="list" v-if="searchForm.type === 1" />
      <video-list :list="list" v-if="searchForm.type === 2" />
      <cartoon-list :list="list" v-if="searchForm.type === 4" />
      <audio-list :list="list" v-if="searchForm.type === 3" />
      <div v-if="list.length === 0" class="empty-text">
        <van-image
          width="300"
          height="auto"
          class=""
          :src="require('@/assets/empty.png')"
        />
        <div>这里空空如也～</div>
      </div>
      <div class="noPagination"></div>
      <Pagination
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @change="search"
      ></Pagination>
    </div>
    <!-- <ul>
      <li>
        <router-link to="/article/1">文章详情1</router-link><br />
        <router-link to="/article/2">文章详情2</router-link>
      </li>
      <li>
        <router-link to="/video/1">视频详情1</router-link>
      </li>
      <li>
        <router-link to="/wallchart/1">漫画详情1</router-link>
      </li>
    </ul> -->
  </div>
</template>
<script>
import TextList from "./components/TextList.vue";
import VideoList from "./components/VideoList.vue";
import CartoonList from "./components/CartoonList.vue";
import AudioList from "./components/AudioList.vue";
import Pagination from "@/components/TheLayout/Pagination.vue";
export default {
  components: {
    TextList,
    VideoList,
    CartoonList,
    AudioList,
    Pagination,
  },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      typeList: [],
      categoryList: [],
      groupList: [],
      searchForm: {
        type: 2,
        category: "0",
        group: "0",
      },
    };
  },
  watch: {
    $route: function () {
      if (this.$route.query.page) {
        this.currentPage = Number(this.$route.query.page);
      }
      this.getList();
    },
  },
  methods: {
    async getList() {
      try {
        const { data } = await this.$axios.post(`Articleeducate/getList`, {
          title: this.$route.query.keyword ? this.$route.query.keyword : "",
          type: this.searchForm.type,
          category: this.searchForm.category,
          crowd: this.searchForm.group,
          page: this.currentPage,
          size: this.pageSize,
        });
        this.list = data.list;
        this.total = Number(data.total);
      } catch (error) {
        this.$toast(error?.errorMSg ?? "暂无数据");
      } finally {
        this.loading = false;
      }
    },
    changeType(id, name) {
      this.searchForm[name] = id;
      if (name === "type") {
        let sizes = [10, 10, 20, 10, 15];
        this.pageSize = sizes[id];
      }
      this.currentPage = 1;
      this.search();
      //this.getList();
    },
    search() {
      this.$router.push({
        path: "/",
        query: {
          keyword: this.$route.query.keyword ? this.$route.query.keyword : "",
          t: Math.random(),
        },
      });
    },
    async getType() {
      try {
        const { data } = await this.$axios.post(
          `Articleeducate/getCategory`,
          {}
        );
        this.typeList = data.type;
        this.categoryList = data.category;
        this.groupList = data.crowd;
      } catch (error) {
        this.$toast(error?.errorMSg ?? "暂无数据");
      }
    },
  },
  created() {
    this.getType();
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
::v-deep .desktop-main {
  background-color: #f2f5ff;
}

.desktop-search {
  overflow: hidden;
}

.ul-main {
  width: 1200px;
  height: auto;
  padding-bottom: 20px;
  margin-top: 20px;
  background-color: white;
}

.class-main {
  width: 1200px;
  height: 315px;
  background: #fff;

  .type-main {
    display: inline-block;
    margin-top: 38px;
  }

  .class-li {
    display: inline-block;
    padding: 9px;
    margin-left: 5px;
    font-size: 20px;
    font-weight: 400;
    line-height: 20px;
    cursor: pointer;
  }

  .class-li-active {
    font-weight: 600;
    color: #fff;
    background: #0047ff;
    border-radius: 2px;
  }

  .category-main {
    display: inline-block;
    margin-top: 35px;

    .class-li {
      margin-bottom: 10px;
    }
  }

  .group-main {
    display: inline-block;
    margin-top: 40px;
  }

  .search-title {
    display: inline-block;
    width: 55px;
    padding: 9px;
    margin-left: 42px;
    font-size: 20px;
    font-weight: bold;
    line-height: 20px;
    color: #0047ff;
    vertical-align: top;
  }

  .items {
    display: inline-block;
    width: 1050px;
    vertical-align: top;
  }
}

.empty-text {
  width: 100%;
  padding: 200px 0;
  font-size: 14px;
  color: #b6daff;
  text-align: center;
}

.noPagination {
  display: flex;
  width: 100%;
}
</style>
